import { ActionConfirmationModal } from "@/components/ui/ActionConfirmationModal/ActionConfirmationModal";
import { Button } from "@/components/ui/shadcn/Button/Button";
import { SLIDEOVER_CONFIRM_CLOSE_DESCRIPTION } from "@/lib/data/static/slideoverStatics";
import { useState } from "react";

export const FormCancelButton = ({
  setOpen,
  isDirty,
  label = "Cancel",
}: {
  setOpen: (open: boolean) => void;
  isDirty?: boolean;
  label?: "Cancel" | "Close";
}) => {
  const [confirmClose, setConfirmClose] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          if (isDirty) {
            setConfirmClose(true);
          } else {
            setOpen(false);
          }
        }}
      >
        {label}
      </Button>
      <ActionConfirmationModal
        open={confirmClose}
        setOpen={(open) => {
          setConfirmClose(open);
        }}
        title="Unsaved changes"
        buttonText="Confirm"
        description={SLIDEOVER_CONFIRM_CLOSE_DESCRIPTION}
        afterActionFn={() => {
          setOpen(false);
          setConfirmClose(false);
        }}
      />
    </>
  );
};
